module.exports={"wireguard adapter settings":"wireguard的适配器设置",option1:"选项1",option2:"选项2"};